import React from 'react'
import '../Styles/Footer.scss'

const Footer = () => {
  return <footer>
    <div>
        <h1>Pramukh Finserve</h1>
    </div>
    <div>
        <h5>Follow Us</h5>
       <div>
        <a href='https://instagram.com/pramukh_finserve' target={"blank"}>Instagram</a>
        <a href='https://www.facebook.com/pramukh.finserve' target={"blank"}>facebook</a>
        <a href='https://wa.me/9537982952' target={"blank"}>WhatsApp</a>
        
        </div> 
    </div>
     </footer>


}

export default Footer